// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { MedicalV1PriorAuthorizationInterfacesPriorAuthorizationDiagnosis } from './medicalV1PriorAuthorizationInterfacesPriorAuthorizationDiagnosis.js';
import type { MedicalV1PriorAuthorizationInterfacesPriorAuthorizationPatient } from './medicalV1PriorAuthorizationInterfacesPriorAuthorizationPatient.js';
import type { MedicalV1PriorAuthorizationInterfacesPriorAuthorizationPayor } from './medicalV1PriorAuthorizationInterfacesPriorAuthorizationPayor.js';
import type { MedicalV1PriorAuthorizationInterfacesPriorAuthorizationPrescription } from './medicalV1PriorAuthorizationInterfacesPriorAuthorizationPrescription.js';
import type { PriorAuthorizationFacility } from './priorAuthorizationFacility.js';
import type { PriorAuthorizationProvider } from './priorAuthorizationProvider.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PriorAuthorizationDeterminationRequest {
    'diagnosis': MedicalV1PriorAuthorizationInterfacesPriorAuthorizationDiagnosis | null;
    'facility': PriorAuthorizationFacility | null;
    'patient': MedicalV1PriorAuthorizationInterfacesPriorAuthorizationPatient | null;
    'payor': MedicalV1PriorAuthorizationInterfacesPriorAuthorizationPayor | null;
    'provider': PriorAuthorizationProvider | null;
    'prescription'?: MedicalV1PriorAuthorizationInterfacesPriorAuthorizationPrescription | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PriorAuthorizationDeterminationRequest>> = [
        {
            "name":     "diagnosis",
            "baseName": "diagnosis",
            "type":     "MedicalV1PriorAuthorizationInterfacesPriorAuthorizationDiagnosis"
        },
        {
            "name":     "facility",
            "baseName": "facility",
            "type":     "PriorAuthorizationFacility"
        },
        {
            "name":     "patient",
            "baseName": "patient",
            "type":     "MedicalV1PriorAuthorizationInterfacesPriorAuthorizationPatient"
        },
        {
            "name":     "payor",
            "baseName": "payor",
            "type":     "MedicalV1PriorAuthorizationInterfacesPriorAuthorizationPayor"
        },
        {
            "name":     "provider",
            "baseName": "provider",
            "type":     "PriorAuthorizationProvider"
        },
        {
            "name":     "prescription",
            "baseName": "prescription",
            "type":     "MedicalV1PriorAuthorizationInterfacesPriorAuthorizationPrescription"
        },
    ];

    static getAttributeTypeMap() {
        return PriorAuthorizationDeterminationRequest.attributeTypeMap;
    }
}
